export default __webpack_public_path__ + "assets/images/aaef2258173a8d7183371ef51d2e5caa.jpg";